import { render, staticRenderFns } from "./DeviceMasterGridVersion.vue?vue&type=template&id=53840740&scoped=true&"
import script from "./DeviceMasterGridVersion.vue?vue&type=script&lang=js&"
export * from "./DeviceMasterGridVersion.vue?vue&type=script&lang=js&"
import style0 from "./DeviceMasterGridVersion.vue?vue&type=style&index=0&id=53840740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53840740",
  null
  
)

export default component.exports